<div class="container mt-0 flex-auto flex-col">
  <div class="sticky top-0 z-10  dark:bg-gray-900">

      <table class="w-full table-fixed mat-elevation-z" mat-table [dataSource]="ordersData" matSort
          (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

          <ng-container matColumnDef="det">
            <th mat-header-cell *matHeaderCellDef style="min-width: 40px; width: 170px;"></th>
            <td mat-cell *matCellDef="let element">
              <div class="flex items-center gap-2 min-w-[102px]">
                <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetails(element)">
                  <mat-icon class="icon-size-5" [svgIcon]="selectedItem?.tripId === element.tripId
                                ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'">
                  </mat-icon>
                </button>
                
                @if(useMap){
                <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="openModal(element)">
                  <mat-icon color="primary" class="cursor-pointer">
                    location_on
                  </mat-icon>
                </button>
                <!-- Ocultado temporalmente en cortijo-qas: ver/reordenar orden de visita del viaje.
                <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="openVisitOrderModal(element)"
                  matTooltip="Orden de visita del viaje">
                  <mat-icon color="primary" class="cursor-pointer" svgIcon="heroicons_outline:list-bullet">
                  </mat-icon>
                </button>
                -->
                }
                <div class="ml-1 mr-4">
                  <app-unified-load-docs-chip
                    [hasUnifiedLoadDocs]="element?.hasUnifiedLoadDocs"></app-unified-load-docs-chip>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="trip">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">Viaje</th>
            <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
              <div class="flex items-center gap-2 min-w-[102px]">
                <span class="flex items-center cursor-pointer" [ngClass]="{ 'underline': element?.tripId }"
                  (click)="element?.tripId && goToTravel(element)" [matTooltip]="element?.tripId ? 'Ir al viaje' : ''">
                  <span>{{ element?.tripId ?? '-' }}</span>
                  <mat-icon *ngIf="element?.tripId" class="ml-2 icon-size-3 hover:animate-bounce"
                    [svgIcon]="'heroicons_outline:rocket-launch'" style="color: rgb(0, 0, 0);">
                  </mat-icon>
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="dateTeoric">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Fecha Teórica</th>
            <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
              <p class="table-text-m" style="min-width: 102px;">
                <span class="f-10">
                  FI:<i>{{element?.tripDateHourStartTeoric | FormatDateHour: false }} </i> <br>
                  FF:<i>{{element?.tripDateHourEndTeoric | FormatDateHour: false }}</i> <br>
                  Duración: <i>{{ element?.tripDateHourStartTeoric | timeDifference: element?.tripDateHourEndTeoric }}</i>
                </span>
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="dateReal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Fecha Real</th>
            <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
              <p class="table-text-m" style="min-width: 102px;">
                FI: <i>{{element?.tripDateHourStart | FormatDateHour: false}}</i><br>
                FF: <i>{{element?.tripDateHourEnd | FormatDateHour: false}}</i><br>
                Duración: <i>{{ element?.tripDateHourStart | timeDifference: element?.tripDateHourEnd }}</i>
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="route">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">Ruta</th>
            <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
              <p class="table-text-m" style="min-width: 102px;">
                <span class="table-text-code">
                  {{ element?.subRouteExternalCode ?? '-' }}<br>
                </span>
                {{ element?.subRouteName ?? '-' }}
              </p>
            </td>
          </ng-container>
        
          <ng-container matColumnDef="weight">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle text-right">
                <span class="table-text-m-2">Carga</span>
              </th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                <p class="table-text-m-2">
                  {{ (element?.weight ?? 23.3 | weightFormat:'lbs') }}
                </p>
              </td>
          </ng-container>

          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class=" text-left first-col" style="min-width: 40px; width: 70px;"></th>
              <td mat-cell *matCellDef="let element" class=" text-left first-col">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <!-- <button *ngIf="element?.statusId != 0 && element?.statusId != 7 && element?.statusId != 8" 
                    mat-menu-item 
                    (click)="showEditOrderModal(element)">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    <span>Editar</span>
                  </button> -->
                </mat-menu>
              </td>
          </ng-container>                

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="border-0 p-0">
              <div *ngIf="selectedItem?.tripId === element.tripId"
                   class="details-row w-full max-w-full overflow-x-auto">
                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: element }"></ng-container>
              </div>
            </td>
          </ng-container>

          <!-- Header Row -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10 bg-white shadow-md shadow-gray-700/10 dark:bg-gray-900"></tr>
          <!-- Fila principal -->
          <tr id="datarow" mat-row *matRowDef="let element; columns: displayedColumns;" class="border-b "
          [ngClass]="{
            'bg-gray-100 hover:bg-gray-100 border-b-2 border-gray-100 mdc-data-table__row--selected' : selectedItem?.tripId === element.tripId,
          }"
          [class.table-expanded-row]="selectedItem?.tripId === element.tripId"></tr>
          <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="table-detail-row"></tr>
      </table>
  </div>
  <div *ngIf="this.ordersData.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
  </div>
</div>



<ng-template #rowDetailsTemplate let-element>
  
  <mat-tab-group class="w-full" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Resumen Material"> 
      <app-summary-material 
      class="block w-full"
       [type]="documentType"
       [summaryData]="selectedItem.materialsSummary"
       [UMPActive]="UMPActive" 
      (onSortChange)="changeSort($event)"
      (refreshMonitor)="onSummaryRefresh()"
      [isAllColumns]="false"></app-summary-material>  
    </mat-tab>
    <mat-tab label="Pedidos">
      <app-order-table [ordersData]="selectedItem.orders"
        [displayedColumns]="['det','select','serial', 'soldTo', 'shipTo','address', 'deliveryDateTime', 'weight', 'actions']"
        (onSortChange)="changeSort($event)"
        [loadCalculationMode]="loadCalculationMode"
         [UMPActive]="UMPActive"
        [documentClasses]="documentClassesLocal()"
        (ordersJoined)="OrderUpdate($event)"
      ></app-order-table>

      <!-- Paginador para Pedidos -->
      <mat-paginator
        [length]="ordersTotalItems"
        [pageSize]="ordersPageSize"
        [pageSizeOptions]="[10, 20, 50, 100]"
        (page)="onOrdersPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </mat-tab>
    <mat-tab label="Unificados">
      <app-unified-table
      [unifiedOrdersData]="selectedItem.unifiedOrders"
      [loadCalculationMode]="loadCalculationMode"
       [UMPActive]="UMPActive"
       (ordersJoined)="OrderUpdate($event)"
       (onExpandUnified)="onExpandUnified($event)">
      </app-unified-table>

      <!-- Paginador para Pedidos Unificados -->
      <mat-paginator
        [length]="unifiedTotalItems"
        [pageSize]="unifiedPageSize"
        [pageSizeOptions]="[10, 20, 50, 100]"
        (page)="onUnifiedPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </mat-tab>
  </mat-tab-group>
      
</ng-template>

<ng-template #noData>
<span>
  -
</span>
</ng-template>



<!-- Modal Editar -->
<ng-template #editModal>
  <!-- <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Pedido</h2>
  <small></small>
  <mat-dialog-content class="modal-content">

        <form [formGroup]="editOrderForm" class="flex flex-col gap-4">

          <div class="w-full">

            <mat-form-field appearance="fill" class="modal-input w-full">
              <mat-label class="block text-gray-700">Rutas</mat-label>
              <mat-select formControlName="route">
                <mat-option *ngFor="let route of routes()" [value]="route.id">{{route.name}}</mat-option>
              </mat-select>
            </mat-form-field>
    
          </div>
          <hr class="m-2">
            <div class="flex flex-row gap-2">
  
            <div class="w-full">
              <mat-form-field class="w-full">
                  <mat-label>Fecha y Hora</mat-label>
                  <input matInput [matDatepicker]="dateend" formControlName="date">
                  <mat-datepicker-toggle matIconSuffix [for]="dateend"></mat-datepicker-toggle>
                  <mat-datepicker #dateend></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="w-full">
              <mat-form-field appearance="fill" class="col-span-1">
                <mat-label></mat-label>
                <mat-icon matSuffix>schedule</mat-icon>
                <input
                  matInput
                  formControlName="time"
                  name="time"
                  placeholder="Inicio"
                  [ngxTimepicker]="default1"
                />
                <ngx-material-timepicker #default1></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>
            
  

            <div class="w-full">

              <mat-form-field appearance="fill" class="modal-input w-full">
                <mat-label class="block text-gray-700">Viajes</mat-label>
                <mat-select formControlName="trip">
                  <mat-option *ngFor="let trip of trips()" [value]="trip.id">{{trip.name}}</mat-option>
                </mat-select>
              </mat-form-field>
      
            </div>
            <hr class="m-2">



          </form>

  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions">
    <button mat-button mat-dialog-close class="align-right">Cancelar</button>
    <button mat-button class="align-right"
    (click)="updateOrder(selectedItem).    >Guardar</button>

  </mat-dialog-actions> -->
</ng-template>